// Use relative imports instead of barrel to avoid circular dependency
// (the barrel's first export is this very module)
import { APIClient } from './api-client';
import { ApiClientType } from './api-clients';
import { auth0Authenticator } from '../app-core/setup/auth0-authenticator';
import { authenticator } from '../app-core/setup/authenticator';
import { axiosIntegrationsBaseInstance } from '../app-core/setup/axios-api';
import { signer } from '../app-core/setup/signer';
import { auth0Signer } from '../app-core/setup/auth0-signer';

export class IntegrationsAPIClient {
  private static baseAPIClient: APIClient | undefined;

  public static setApiClient(apiClientType: ApiClientType): void {
    switch (apiClientType) {
      case ApiClientType.Aws:
        IntegrationsAPIClient.baseAPIClient = new APIClient(axiosIntegrationsBaseInstance, signer, authenticator);
        break;
      case ApiClientType.Auth0:
        IntegrationsAPIClient.baseAPIClient = new APIClient(
          axiosIntegrationsBaseInstance,
          auth0Signer,
          auth0Authenticator
        );
        break;
      default:
        throw new Error('Unsupported auth type');
    }
  }

  public static getAPIClient(): APIClient {
    if (!IntegrationsAPIClient.baseAPIClient) {
      throw new Error('API client has not been set. Call setApiClient first.');
    }

    return IntegrationsAPIClient.baseAPIClient;
  }
}
